module.exports = __webpack_public_path__ + "banquet/components/images/info-circle.7d73d3285783c28398b072a0a84cc7fb.svg";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/images/info-circle.svg
// module id = 1707
// module chunks = 1